import {NgModule} from '@angular/core';
import {EtsFitToViewportDirective} from './ets-fit-to-viewport.directive';

/**
 * Standalone module exposing {@link EtsFitToViewportDirective}. Kept dependency-free, like
 * {@link EtsDraggableModule}, so the Hedging Grid and APG modules can import it directly.
 */
@NgModule({
    declarations: [EtsFitToViewportDirective],
    exports: [EtsFitToViewportDirective]
})
export class EtsFitToViewportModule {
}
